<template>
  <button class="back-button" @click="goBack">
    <i class="fas fa-arrow-left"></i>
  </button>
</template>
<script>
export default {
  name: "BackButton",
  props: {},
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss">
.back-button {
  vertical-align: middle;
  border: none;
  font-size: 2rem;
  margin-right: 1.6rem;
  text-align: center;
  cursor: pointer;

  background-color: #242424;
  border-radius: 50%;
  color: #ffffff;
  outline: none;
}
</style>
